import './jobListStyles.css'

import { Button } from '@atd/rui-base.mui.button'
import { Dialog } from '@atd/rui-base.mui.dialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'
import { Fab } from '@atd/rui-base.mui.fab'
import React, { useEffect, useState } from 'react'
import { Tab } from '@atd/rui-base.mui.tab'
import { Tabs } from '@atd/rui-base.mui.tabs'
import {fetchWorkorders, setWorkorderArchived} from './workorderActions'
import { useDispatch, useSelector } from 'react-redux'

import AddIcon from '@mui/icons-material/Add'
import JobCard from './jobCard'
import JobCardLoader from './jobCardLoader'
import JobListEmpty from './jobListEmpty'
import JobListFilter from './jobListFilter'
import JobListSummary from './jobListSummary'
import ListPaging from '../commonComponents/listPaging'
import {add} from 'date-fns'

const JobList = () => {
    const dispatch = useDispatch()
    const [archiveDialogOpen, setArchiveDialogOpen] = useState(false)
    const [filteredCards, setFilteredCards] = useState([])
    const [viewList, setViewList] = useState([])
    const [viewMode, setViewMode] = useState('list')
    const [isLoaded, setIsLoaded] = useState(false)

    const workorderStore = useSelector(store => store.workorder)
    const {filteredJobs, jobListFilter: filterOptions, isFetching} = workorderStore
    const unarchivedJobCount = filteredJobs.filter(j => !j.archived).length

    const createCard = (data, i) => {
        return <JobCard key={data.guid} guid={data.guid} />
    }

    const onViewListChanged = (newItems) => {
        setViewList([...newItems])
        setIsLoaded(true)
    }

    const archiveAllJobs = () => {
        for (const job of filteredJobs) {
            if (!job.archived) {
                dispatch(setWorkorderArchived(job.id, true))
            }
        }
        setArchiveDialogOpen(false)
    }

    const handleArchiveAllRequest = () => {
        setArchiveDialogOpen(true)
    }

    const handleCancel = () => {
        setArchiveDialogOpen(false)
    }

    const renderArchiveDialog = () => {
        if (!archiveDialogOpen) { return }
        const archiveActions = [
            <Button variant="text"
                key="cancel"
                onClick={handleCancel}
                name="cancelArchive"
                color="primary">Cancel</Button>,
            <Button variant="text"
                key="archive"
                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_BtnArchiveJob.svg`}/>}
                color="primary"
                onClick={archiveAllJobs}
                name="confirmArchive">Archive</Button>,
        ]

        return (
            <Dialog
                open={true}
                onClose={handleCancel}
            >
                <DialogContent>
                    <p>Do you wish to archive available jobs?</p>
                    <p>Filtered Total: {unarchivedJobCount}</p>
                </DialogContent>
                <DialogActions>{archiveActions}</DialogActions>
            </Dialog>
        )
    }

    const renderPageHeader = () => {
        return (
            <div className="jobListLayout">
                <Tabs
                    variant="fullWidth"
                    sx={{flexGrow: 2}}
                    name="viewModeToggle"
                    value={viewMode}
                    onChange={(_, mode) => setViewMode(mode)}
                >
                    <Tab
                        value="list"
                        label="List"
                        sx={{
                            color: '#bdbdbd',
                            backgroundColor: 'var(--secondary)',
                            '&.Mui-selected': {backgroundColor: 'var(--primary)', color: '#fff'},
                        }}
                        name="listViewButton"
                    />
                    <Tab
                        value="summary"
                        label="Summary"
                        sx={{
                            color: '#bdbdbd',
                            backgroundColor: 'var(--secondary)',
                            '&.Mui-selected': {backgroundColor: 'var(--primary)', color: '#fff'},
                        }}
                        name="summaryViewButton"
                    />
                </Tabs>
                <span name="searchPlaceholder" style={{flexGrow: 1}}/>
                <Button variant="contained"
                    color="primary"
                    startIcon={<img className="filterOption" src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_BtnArchiveJob${unarchivedJobCount ? 'White' : 'Disabled'}.svg`}/>}
                    onClick={handleArchiveAllRequest}
                    className="archiveAll desktopOnly"
                    disabled={!unarchivedJobCount}>{`Archive (${unarchivedJobCount})`}</Button>
            </div>
        )
    }

    const renderBody = () => {
        if (viewMode == 'list') {
            return (
                <div style={{width: '100%'}}>
                    <div className="jobList" name="jobList">
                        {!isLoaded && !filterOptions.error.value && Array(8).fill().map((item, index) => (<JobCardLoader key={index}/>))}
                        {!isFetching && !filterOptions.error.value && isLoaded && filteredJobs.length > 0 && viewList}
                        {!isFetching && isLoaded && (filteredJobs.length === 0 || filterOptions.error.value) && <JobListEmpty error={filterOptions.error}/>}
                    </div>
                    <ListPaging
                        itemList={filteredCards}
                        viewListChanged={onViewListChanged}
                        countPerPage={20}
                    />
                </div>
            )
        }
        else if (viewMode == 'summary') {
            return (
                <div style={{width: '100%', margin: '15px 0px'}}>
                    <h2 className="desktopOnly">Summary</h2>
                    <JobListSummary/>
                </div>

            )
        }
    }

    useEffect(() => {
        let startDate = null
        let endDate = null
        const localDate = new Date()
        const localTimeZoneOffset = localDate.getTimezoneOffset()
        if ((filterOptions.endDate)) {
            endDate = add(filterOptions.endDate, {minutes: localTimeZoneOffset})
            endDate = add(endDate, {hours: 24}) // end of day
        }
        if (filterOptions.startDate) {
            startDate = add(filterOptions.startDate, {minutes: localTimeZoneOffset})
        }
        if (Object.keys(filterOptions).length > 0) {
            dispatch(fetchWorkorders({...filterOptions, startDate, endDate}))
        }
    }, [filterOptions])

    useEffect(() => {
        if (isFetching) {
            setIsLoaded(false)
        }
    }, [isFetching])

    useEffect(() => {
        if (!isFetching) {
            setFilteredCards(filteredJobs.map(createCard))
        }
    }, [filteredJobs])

    return (
        <div>
            <div className="jobListLayout">
                <JobListFilter />
                <div style={{width: '100%'}}>
                    {renderPageHeader()}
                    {renderBody()}
                </div>
            </div>
            <Fab
                className="floatingArchiveMobile"
                onClick={handleArchiveAllRequest}
                disabled={!unarchivedJobCount}
                style={unarchivedJobCount ? {} : {display: 'none'}}
                sx={{backgroundColor: 'var(--primary)', '&:hover': {backgroundColor: 'var(--primary)'}}}>
                <img className={'mobileArchiveIcon'} src={`${process.env.PUBLIC_URL}/images/jobCard/JobCard_BtnArchiveJob${unarchivedJobCount ? 'White' : 'Disabled'}.svg`}/>
            </Fab>
            <Fab
                className="floatingAddMobile"
                href={'/jobs/create'}
                sx={{backgroundColor: 'var(--primary)', '&:hover': {backgroundColor: 'var(--primary)'}}}>
                <AddIcon htmlColor="white"/>
            </Fab>
            {renderArchiveDialog()}
        </div>
    )
}

export default JobList
